import { get } from 'lodash';
export var entityColorInfo = function (entity, options) {
  var opts = {};
  var color = get(entity, 'color.value', 'strong');
  var backgroundColor = get(entity, 'backgroundColor.value', 'transparent');
  var themeMode = get(entity, 'themeMode.slug');
  var isInverted = themeMode === 'dark';
  // const hasBothColors = !!entityColor && !!entityBackgroundColor;
  // const hasColor = !!entityColor && !entityBackgroundColor;
  // const hasBackgroundColor = !entityColor && !!entityBackgroundColor;
  // const color = hasBothColors ? entityColor : (hasBackgroundColor ? (isDarkColor(entityBackgroundColor) ? opts.defaultLightColor : opts.defaultDarkColor) : (entityColor || opts.defaultDarkColor));
  // const backgroundColor = hasBothColors ? entityBackgroundColor : (hasColor ? (isLightColor(entityColor) ? opts.defaultDarkColor : opts.defaultLightColor) : entityBackgroundColor);
  // const isInverted = isLightColor(color);
  return {
    color: color,
    backgroundColor: backgroundColor,
    isInverted: isInverted
  };
};
export var sliceColorInfo = entityColorInfo;